import _ from 'underscore';
import NavigationUtil from 'utils/NavigationUtil';
import Backbone from 'backbone';

var PartialModel = Backbone.Model.extend({
    // Optional, required props will always be sent to API
    required: null,

    isReady: false,

    // All changed properties + required to be sent
    // Will be reset after sending to API
    changedProps: null,

    constructor: function(props) {
        this._reset();
        this.on(
            'sync',
            function() {
                this.isReady = true;
            }.bind(this)
        );
        Backbone.Model.apply(this, arguments);
    },

    setRequired: function(required) {
        this.required = required;
    },

    // Support normal and partial change in nested object
    // Ex: set({
    //             userData: {
    //                 activityClass: 5
    //             }
    //         })
    set: function(attributes, options) {
        if (this.isReady) {
            if (typeof attributes === 'object') {
                jQuery.extend(true, this.changedProps, attributes);
                // if array is changed, submit the entire array
                for (var prop in attributes) {
                    if (attributes.hasOwnProperty(prop) && _.isArray(attributes[prop])) {
                        this.changedProps[prop] = attributes[prop];
                    }
                }
                this._mergeChanges(attributes);
            } else {
                this.changedProps[attributes] = options;
            }
        }
        return Backbone.Model.prototype.set.call(this, attributes, options);
    },

    save: function(attributes, options = {}) {
        if (!this.hasChangedProps()) {
            // Nothing has changed, no need to save
            return true;
        }

        let data = jQuery.extend(true, {}, this.changedProps, this.required);

        let opts = { ...options } || {};
        opts.attributes = data;
        //attr set because of the usage in ConnectSync - by default the key should be attributes
        opts.attrs = data;
        opts.emulateHTTP = false;

        opts.success = (data, statusText, jqXHR) => {
            if (typeof options.success === 'function') {
                options.success(data, statusText, jqXHR);
            }
            this._updateModel(data);
            this.trigger('sync', this, data);
            this._reset();
        };

        this.sync('update', this, opts);
    },

    hasChangedProps: function() {
        return !_.isEmpty(this.changedProps);
    },

    _reset: function() {
        this.changedProps = {};
    },

    _updateModel: function(data) {
        if (!data) {
            return;
        }

        for (var prop in this.changedProps) {
            if (this.changedProps.hasOwnProperty(prop)) {
                this.attributes[prop] = data[prop];
            }
        }
    },

    // Merge attributes with current model, keep the latest change
    _mergeChanges: function(attributes) {
        var merged = jQuery.extend(true, {}, this.attributes, attributes);
        for (var prop in attributes) {
            if (attributes.hasOwnProperty(prop) && !_.isArray(attributes[prop])) {
                attributes[prop] = merged[prop];
            }
        }
    }
});

export default PartialModel;
